<template>
  <div class="container-fluid">
    <div class="row h-100">
      <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
      <!--
      ==================
       dashboard page
      ==================
     -->
      <div class="col-sm p-0">
        <div class="vesselschedule global__scrollcustom">
          <div class="vesselschedule__wrapper global__scrollcustom">
            <h1 class="font-weight-bold" style="font-size: 24px">Vessel Schedule</h1>
            <FormVesselSchedule :quotaSchedule="quotaSchedule" />
            <ResultVesselSchedule :quotaSchedule="quotaSchedule" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/global/Sidebar.vue'
import SectionNotFound from '@/components/vesselSchedule/SectionNotFound.vue'
import CardResult from '@/components/vesselSchedule/CardResult.vue'
import FormVesselSchedule from '@/components/vesselSchedule/FormVesselSchedule.vue'
import ResultVesselSchedule from '@/components/vesselSchedule/ResultVesselSchedule.vue'
import { mapGetters } from 'vuex'
// eslint-disable-next-line import/no-cycle
import mixin from '@/mixin'

export default {
  name: 'VesselSchedule',
  components: {
    Sidebar,
    FormVesselSchedule,
    ResultVesselSchedule,
    CardResult,
    SectionNotFound
  },
  mixins: [mixin],
  data () {
    return {
      filterShippingLine: {
        list: [],
        checked: []
      },
      quotaSchedule: 0,
      allowSearchSchedule: true
    }
  },
  computed: {
    ...mapGetters({
      company: 'settingCompany/company'
    })
  },
  mounted () {},
  methods: {
    resetFilter () {
      this.filterShippingLine.list = []
      this.filterShippingLine.checked = []
    }
  },
  watch: {
    company (newVal, prevVal) {
      if (newVal) {
        // if (!prevVal) {
        //   this.quotaSchedule = newVal.ship_schedule_quota
        // } else if (newVal.ship_schedule_quota !== 0) {
        //   this.quotaSchedule = newVal.ship_schedule_quota
        // } else if (newVal.ship_schedule_quota === 0 && prevVal.ship_schedule_quota === 0) {
        //   this.quotaSchedule = newVal.ship_schedule_quota
        // }
        this.quotaSchedule = newVal.ship_schedule_quota
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/vesselSchedule/index.vue